import { Text, Img, Heading } from "./..";
import React from "react";

export default function EventDetails({
  eventTitle,
  locationText = "Cairo, Egypt",
  eventPrice = "200 EGP",
  goingText = "+20 Going",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col sm:flex-col md:w-full gap-2 p-2 border-blue_gray-50 border-solid bg-white-a700 sm:min-w-[285px]`}
    >
      <Img src="images/img_image_84.png" alt="Image" className="h-[132px] w-full rounded-md object-cover" />
      <div className="mb-3 ml-2.5 mr-3.5 flex flex-col items-start justify-center gap-1.5 self-stretch">
        <Text size="text3xl" as="p" className="!font-avenirarabic text-[18px] font-extrabold !text-black-900_01">
          <span>The 3 Most Impactful&nbsp;</span>
          <span>...</span>
        </Text>
        <div className="flex items-start justify-between gap-5 self-stretch">
          <div className="flex w-[38%] flex-col items-start gap-1.5 self-center">
            <div className="flex gap-1.5 self-stretch">
              <Img src="images/img_map_pin.svg" alt="Cairoegypt" className="h-[16px]" />
              <Text size="textmd" as="p" className="text-[13px] font-normal !text-blue_gray-900">
                {locationText}
              </Text>
            </div>
            <Heading as="h6" className="!font-avenirarabic text-[16px] font-black !text-orange-900">
              {eventPrice}
            </Heading>
          </div>
          <div className="flex items-center">
            <Img src="images/img_contrast.svg" alt="20 Going" className="h-[16px]" />
            <Text as="p" className="ml-1 text-[12px] font-normal">
              {goingText}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
